<template>
  <div class="crewHome">
    <div class="crewHome-content" style="position: relative">
      <el-form :inline="true" :model="formInline" class="other-form-left">
        <el-form-item label="船舶:" style="margin-left: 10px">
          <el-input
            v-model="formInline.shipName"
            style="width: 100px"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="月份:">
          <el-input
            v-model="formInline.month"
            style="width: 100px"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="奖惩比:">
          <el-input
            v-model="formInline.rewardPunishmentRate"
            style="width: 100px"
            :readonly="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-form :inline="true" :model="formInline" class="other-form-inline">
        <el-form-item v-if="excellType == '2'">
          <div class="other-check" @click="chooseCrew()">选择船员</div>
        </el-form-item>
        <el-form-item>
          <div class="other-search3" @click="exportExcel()">导出</div>
        </el-form-item>
      </el-form>
      <div style="clear: both"></div>
      <el-divider class="other-divider"></el-divider>
      <div class="other-table-energy" style="overflow: auto">
        <el-table
          :data="tableData"
          style="width: 100%"
          show-summary
          header-row-class-name="other-header"
          row-class-name="other-row"
        >
          <el-table-column prop="userName" label="船员姓名" min-width="100">
          </el-table-column>
          <el-table-column prop="postName" label="职务" min-width="100">
          </el-table-column>
          <el-table-column prop="" label="船员类型" min-width="80">
            <template slot-scope="scope">
              <span>{{
                scope.row.crewType == 1
                  ? "自有船员"
                  : scope.row.crewType == 2
                  ? "外包船员"
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="在船天数" min-width="120">
            <template slot-scope="scope">
              <div v-if="excellType == 2">
                <el-input
                  v-model="scope.row.onBoardDays"
                  @change="getTotal(scope.row)"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div v-if="excellType == 1">{{ scope.row.onBoardDays }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="薪资标准" min-width="100">
            <template slot-scope="scope">
              <div v-if="excellType == 2">
                <el-input
                  v-model="scope.row.salaryStandard"
                  @change="getTotal(scope.row)"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div v-if="excellType == 1">{{ scope.row.salaryStandard }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="奖惩比(%)" min-width="100">
            <template slot-scope="scope">
              <div v-if="excellType == 2">
                <el-input
                  v-model="scope.row.rewardPunishmentRate"
                  @change="getTotal(scope.row)"
                  type="number"
                  size="mini"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div v-if="excellType == 1">
                {{ scope.row.rewardPunishmentRate }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="energySavingTotal"
            label="节能考核费用"
            min-width="100"
          >
            <!-- <template slot-scope="scope">
              <div v-if="excellType == 2">
                <el-input
                  v-model="scope.row.energySavingTotal"
                  @change="getTotal(scope.row)"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div v-if="excellType == 1">
                {{ scope.row.energySavingTotal }}
              </div>
            </template> -->
          </el-table-column>
          <el-table-column
            prop="outsourcingEnergySavingTotal"
            label="劳务费用合计"
            min-width="100"
          >
            <!-- <template slot-scope="scope">
              <div v-if="excellType == 2">
                <el-input
                  v-model="scope.row.outsourcingEnergySavingTotal"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div v-if="excellType == 1">
                {{ scope.row.outsourcingEnergySavingTotal }}
              </div>
            </template> -->
          </el-table-column>
          <el-table-column
            prop="ownerEnergySavingTotal"
            label="自有船员工资合计"
            min-width="100"
          >
            <!-- <template slot-scope="scope">
              <div v-if="excellType == 2">
                <el-input
                  v-model="scope.row.ownerEnergySavingTotal"
                  oninput="value=value.replace(/^\./g, '').replace(/[^\d.]/g,'').replace(/\.{2,}/g,'')"
                  size="mini"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div v-if="excellType == 1">
                {{ scope.row.ownerEnergySavingTotal }}
              </div>
            </template> -->
          </el-table-column>
          <el-table-column
            label="操作"
            min-width="100"
            v-if="excellType == '2'"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="other-watch"
                @click="delCrew(scope.$index)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="energy-footer" v-if="excellType != '2'"></div>
      <div class="energy-footer" v-if="excellType == '2'">
        <div class="energy-button1" @click="goback()">返回</div>
        <div class="energy-button2" @click="energySumbit()">核准</div>
      </div>
    </div>
    <addCrew ref="addCrew" @choseShip="choseShip"></addCrew>
  </div>
</template>
<script>
import {
  getSpecialEnergySavingUserList,
  energySavingUpdateOrApprove,
  getSpecialEnergySavingShipDetail,
  // exportEnergyExcel,
} from "@/apis/index";
import addCrew from "./addCrew";
import { apiJob } from "@/config";
export default {
  data() {
    return {
      formInline: {},
      tableData: [],
      tableData2: [],
      labelVal: "管理费(10%)",
      currentPage1: 1,
      pageNo: "1",
      total: 0,
      pageSize: 100,
      companyVisible: false,
      jobParams: {},
      remendLoading: false,
      diaList: {},
      rules: {
        userState: [
          {
            required: true,
            message: "请选择员工在本派遣机构状态",
            trigger: "blur",
          },
        ],
      },
      excellType: "",
      tableVisible: false,
    };
  },
  components: {
    addCrew,
  },
  mounted() {
    this.excellType = this.$route.params.type;
    this.getCrewInfoList();
    this.getSpecialEnergySavingShipDetail();
  },
  methods: {
    onSubmit() {
      this.pageNo = 1;
      this.getCrewInfoList();
    },
    handleOpen() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCrewInfoList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getCrewInfoList();
      // console.log(`当前页: ${val}`);
    },
    choseCom() {
      this.companyVisible = true;
    },
    async getCrewInfoList() {
      let res = await getSpecialEnergySavingUserList({
        specialEnergySavingShipId: this.$route.params.id,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
      });
      this.total = res.data.rowCount;
      this.tableData = res.data.resultList;
      this.tableData.forEach((item) => {
        if (item.inviteTime) {
          item.inviteTime = item.inviteTime.split(" ")[0];
        }
      });
    },
    async getSpecialEnergySavingShipDetail() {
      let res = await getSpecialEnergySavingShipDetail({
        energySavingShipId: this.$route.params.id,
      });
      this.formInline = res.data || {};
      // console.log(res);
    },

    energySumbit() {
      this.$confirm("确定核准吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          this.delList();
          // console.log(scope);
        })
        .catch(() => {});
    },
    async delList() {
      this.tableVisible = false;
      this.tableData.forEach((item) => {
        if (!item.onBoardDays && item.onBoardDays != "0") {
          this.tableVisible = true;
        }
        if (!item.salaryStandard && item.salaryStandard != "0") {
          this.tableVisible = true;
        }
      });
      if (this.tableVisible) {
        this.$message.warning("数据不能为空");
        return;
      }
      this.formInline.ismSalarySpecialEnergySavingUserDOS = this.tableData;
      this.formInline.approveState = "1";
      let res = await energySavingUpdateOrApprove(this.formInline);
      if (res.code == "1") {
        this.$message({
          message: "核准成功",
          type: "success",
        });
        this.excellType = "1";
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }

      // console.log(res);
      // this.getCrewInfoList();
    },
    passInvite(scope) {
      this.jobParams = {};
      this.diaList = scope.row;
      this.companyVisible = true;
    },
    rememendCrewPass() {
      if (!this.jobParams.userState) {
        this.$message({
          message: "请选择是否属于本公司",
          type: "error",
        });
        return;
      }
      this.remendLoading = true;
      this.addCrewList();
    },
    goback() {
      this.$router.go(-1);
    },
    exportExcel() {
      // await exportEnergyExcel({
      //   specialEnergySavingShipId: this.$route.params.id,
      // });
      window.open(
        `${apiJob}/exportSpecialEnergySavingUserList/exportExcel?token=${sessionStorage.getItem(
          "agenToken"
        )}&specialEnergySavingShipId=${this.$route.params.id || ""}`
      );
    },
    chooseCrew() {
      let list = this.tableData.filter((val) => {
        return val.shipId.indexOf("、") < 0;
      });
      let shipId = this.formInline.shipId;
      this.$refs.addCrew.showToggle(list, shipId);
    },
    choseShip(val) {
      // let newTabel = [];
      val.forEach((item) => {
        // item.salaryStandard = item.standardSalary;
        this.$set(item, "salaryStandard", item.standardSalary);
        this.tableData.forEach((el) => {
          item.rewardPunishmentRate = el.rewardPunishmentRate;
          if (item.userId == el.userId && item.postName == el.postName) {
            item.onBoardDays = el.onBoardDays;
            item.salaryStandard = el.salaryStandard;
            item.energySavingTotal = el.energySavingTotal;
            item.outsourcingEnergySavingTotal = el.outsourcingEnergySavingTotal;
            item.ownerEnergySavingTotal = el.ownerEnergySavingTotal;
          }
        });
      });
      val.forEach((item) => {
        if (!item.onBoardDays) {
          this.$set(item, "onBoardDays", "");
        }
        if (!item.salaryStandard) {
          this.$set(item, "salaryStandard", "");
        }
        if (!item.energySavingTotal) {
          this.$set(item, "energySavingTotal", "");
        }
        if (!item.outsourcingEnergySavingTotal) {
          this.$set(item, "outsourcingEnergySavingTotal", "");
        }
        if (!item.ownerEnergySavingTotal) {
          this.$set(item, "ownerEnergySavingTotal", "");
        }
        if (!item.rewardPunishmentRate) {
          this.$set(
            item,
            "rewardPunishmentRate",
            this.formInline.rewardPunishmentRate
          );
        }
      });
      this.tableData = val;
    },
    delCrew(index) {
      this.tableData.splice(index, 1);
    },
    precisionRound(num, decimals = 0) {
      // 处理精度问题：先放大为整数，避免浮点数运算误差
      const factor = Math.pow(10, decimals);
      // 使用Number.EPSILON修正极小数误差
      const scaled =
        num * factor + (num >= 0 ? Number.EPSILON : -Number.EPSILON);

      // 提取小数部分（此时已转换为整数运算，避免精度问题）
      const fractional = scaled % 1;

      if (Math.abs(fractional) >= 0.5) {
        // 向绝对值更大的方向取整
        return scaled < 0
          ? Math.floor(scaled) / factor
          : Math.ceil(scaled) / factor;
      } else {
        // 向绝对值更小的方向取整
        return scaled < 0
          ? Math.ceil(scaled) / factor
          : Math.floor(scaled) / factor;
      }
    },
    getTotal(item) {
      let year = this.formInline.month.split("-")[0];
      let premonth = this.formInline.month.split("-")[1];
      let prevMonth = premonth == 1 ? 12 : premonth - 1;
      let date = new Date(year, prevMonth, 0);
      let days = date.getDate();
      this.$set(
        item,
        "energySavingTotal",
        this.precisionRound(
          (((item.onBoardDays * item.salaryStandard) / days) *
            item.rewardPunishmentRate) /
            100
        )
      );
      if (item.crewType == "1") {
        // Math.ceil(el[4] * el[3] / $scope.days * el[5] / 100)
        this.$set(
          item,
          "ownerEnergySavingTotal",
          this.precisionRound(
            (((item.onBoardDays * item.salaryStandard) / days) *
              item.rewardPunishmentRate) /
              100
          )
        );
      } else if (item.crewType == "2") {
        this.$set(
          item,
          "outsourcingEnergySavingTotal",
          this.precisionRound(
            (((item.onBoardDays * item.salaryStandard) / days) *
              item.rewardPunishmentRate) /
              100
          )
        );
      }
    },
    // async addCrewList() {
    //   let res = await crewAudit({
    //     userState: this.jobParams.userState,
    //     crewType: this.jobParams.crewType,
    //     agentAuditState: "2",
    //     userId: this.diaList.userId,
    //     agentCyAuditId: this.diaList.agentCyAuditId,
    //     userOrigin: "2",
    //   });
    //   if (res.code == 1) {
    //     this.$message({
    //       message: "成功",
    //       type: "success",
    //     });
    //     this.remendLoading = false;
    //     this.companyVisible = false;
    //     this.getCrewInfoList();
    //     // this.$router.push({ name: "邀请船员" });
    //   } else {
    //     this.$message({
    //       message: res.msg,
    //       type: "warning",
    //     });
    //     this.remendLoading = false;
    //     this.companyVisible = false;
    //   }
    //   // console.log(res);
    // },
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0.5em;
  height: 0.5em;
}

/* 隐藏滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 隐藏滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: transparent;
}
</style>
